"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var FormComponent_1 = require("@/pages/common/components/FormComponent");
var Validator_1 = require("@/utils/Validator");
var InvestorFormComponent = /** @class */ (function (_super) {
    __extends(InvestorFormComponent, _super);
    function InvestorFormComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onBlurHandlers = {
            fullname: _this.onBlurHandler('fullname', [Validator_1.fieldRequired('fullname')]),
        };
        _this.onBlurHandlersFields = {
            email: _this.onBlurHandlerFields('email', ['phone'], [Validator_1.emailOptional, Validator_1.eitherFieldRequired(['phone', 'email'])]),
            phone: _this.onBlurHandlerFields('phone', ['email'], [Validator_1.phoneOptional, Validator_1.eitherFieldRequired(['phone', 'email'])]),
        };
        return _this;
    }
    InvestorFormComponent.prototype.render = function () {
        var _this = this;
        var _a = this.state, ui = _a.ui, tForm = _a.tForm, form = _a.form;
        var buttonClass = "o-btn o-btn--primary o-btn--long " + (ui.isLoading ? 'o-btn--loading' : '');
        var disabled = function (field) {
            if (ui.isLoading)
                return { disabled: true };
        };
        var renderNameErrors = function () {
            return _this.renderError('fullname');
        };
        var renderSalutation = function (salutation, index) {
            return (React.createElement("option", { key: index, value: salutation[0] }, salutation[1]));
        };
        var isRequired = function (field) {
            return ['fullname', 'email', 'phone'].indexOf(field) >= 0;
        };
        var fieldClass = function (field) { return classnames_1.default([
            'c-form__input-subgroup',
            'c-form__field',
            {
                'c-form__field--disabled': ui.isLoading,
                'c-form__field--required': isRequired(field),
            },
        ]); };
        var phoneBlurHandler = function () {
            _this.onBlurHandlersFields.email({});
            _this.onBlurHandlersFields.phone({});
        };
        var emailBlurHandler = function () {
            _this.onBlurHandlersFields.phone({});
            _this.onBlurHandlersFields.email({});
        };
        return (React.createElement("form", { id: "investorForm", className: "c-form", onSubmit: this.onSubmitHandler() },
            React.createElement("div", { className: "c-form__row" },
                React.createElement("div", { className: "c-form__input-group" },
                    React.createElement("div", { className: "c-form__input-subgroup c-form__addon" },
                        React.createElement("i", { className: "icon-user u-line-icon-pro" })),
                    React.createElement("div", { className: fieldClass('fullname') },
                        React.createElement("input", __assign({ id: "investorInputFullName", type: "input", className: "c-form__subfield", placeholder: tForm.placeholderFullName, value: form.fullname, onChange: this.onChangeHandler('fullname'), onBlur: this.onBlurHandlers.fullname }, disabled('lastname'))))),
                renderNameErrors()),
            React.createElement("div", { className: "c-form__row" },
                React.createElement("div", { className: "c-form__input-group" },
                    React.createElement("div", { className: "c-form__input-subgroup c-form__addon" },
                        React.createElement("span", { className: "fal fa-briefcase" })),
                    React.createElement("div", { className: fieldClass('company') },
                        React.createElement("input", __assign({ id: "investorInputCompnay", type: "input", className: "c-form__subfield", placeholder: tForm.placeholderCompany, value: form.company, onChange: this.onChangeHandler('company') }, disabled('company')))))),
            React.createElement("div", { className: "c-form__row" },
                React.createElement("div", { className: "c-form__input-group" },
                    React.createElement("div", { className: "c-form__input-subgroup c-form__addon" },
                        React.createElement("span", { className: "fal fa-envelope" })),
                    React.createElement("div", { className: fieldClass('email') },
                        React.createElement("input", __assign({ id: "investorInputEmail", type: "input", className: "c-form__subfield", placeholder: tForm.placeholderEmail, value: form.email, onChange: this.onChangeHandler('email'), onBlur: emailBlurHandler }, disabled('email'))))),
                this.renderError('email')),
            React.createElement("div", { className: "c-form__row" },
                React.createElement("div", { className: "c-form__input-group" },
                    React.createElement("div", { className: "c-form__input-subgroup c-form__addon" },
                        React.createElement("span", { className: "fal fa-phone" })),
                    React.createElement("div", { className: fieldClass('phone') },
                        React.createElement("input", __assign({ id: "investorInputPhone", type: "input", className: "c-form__subfield", placeholder: tForm.placeholderPhone, value: form.phone, onChange: this.onChangeHandler('phone'), onBlur: phoneBlurHandler }, disabled('phone'))))),
                this.renderError('phone')),
            React.createElement("div", { className: "c-form__row" },
                React.createElement("div", { className: "c-form__input-group" },
                    React.createElement("div", { className: "c-form__input-subgroup c-form__addon" },
                        React.createElement("span", { className: "fal fa-comment" })),
                    React.createElement("div", { className: fieldClass('comment') },
                        React.createElement("textarea", { id: "investorInputComment", className: "c-form__subfield", placeholder: tForm.placeholderComment, value: form.comment, onChange: this.onChangeHandler('comment'), disabled: ui.isLoading })))),
            React.createElement("div", { className: "c-form__row" },
                React.createElement("div", { className: "c-form__actions c-form__actions--center" },
                    React.createElement("button", { id: "enquireSubmitButton", disabled: ui.isLoading, className: buttonClass, type: "submit" }, tForm.nameSubmit)))));
    };
    return InvestorFormComponent;
}(FormComponent_1.default));
exports.default = InvestorFormComponent;
